import Vue from 'vue'
import Router from 'vue-router'

const Index = () => import('../pages/Index')
const About = () => import('../pages/About')
const Products = () => import('../pages/Products')
const Cases = () => import('../pages/Cases')
const Users = () => import('../pages/Users')
const Adds = () => import('../pages/Adds')
const ContactUs = () => import('../pages/ContactUs')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: '鹰海医疗信息'
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: {
        title: '走进鹰海'
      }
    },
    {
      path: '/productsAndServices',
      name: 'Products',
      component: Products,
      meta: {
        title: '产品服务'
      }
    },
    {
      path: '/typicalCases',
      name: 'Cases',
      component: Cases,
      meta: {
        title: '典型案例'
      }
    },
    {
      path: '/typicalUsers',
      name: 'Users',
      component: Users,
      meta: {
        title: '典型用户'
      }
    },
    {
      path: '/Adds',
      name: 'Adds',
      component: Adds,
      meta: {
        title: '加入我们'
      }
    },
    {
      path: '/contactUs',
      name: 'ContactUs',
      component: ContactUs,
      meta: {
        title: '联系我们'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js